import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5fqncx9pfy: FaireBrandEntity = {
  token: "b_5fqncx9pfy",
  type: "brand",
  name: "Artifaqt",
  avatarUrl:
    "https://cdn.faire.com/fastly/758c2c6f7149e50d772174b9808916d8117af674f73add2c708443e94f31720f.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/a74f410ec9d22757d065dfe64e81a9364a03c080e45ba82577be03b55fc467a5.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/758c2c6f7149e50d772174b9808916d8117af674f73add2c708443e94f31720f.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a74f410ec9d22757d065dfe64e81a9364a03c080e45ba82577be03b55fc467a5.jpeg",
  location: "Phoenixville, PA, USA",
  minimumOrderDollars: 200,
  rating: 5,
  reviewCount: 4,
  isInsider: true,
  description:
    "~ FIRST TIME BUYERS must message Artifaqt BEFORE placing an order. Please provide your web/social information. Thank you!  ~ Artifaqt is a small family business located in Phoenixville, PA. Our candles are the result of 30 years of mold making experience, a lifelong love of beeswax and a passion for handmade goods. They are designed by nature and made by us! We use the finest Pennsylvania beeswax that we can source. ",
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:06:21.147Z",
    importedBy: "entity-db-cli",
  },
};
